const deviceSizes = {
  mobile: '335px',
  tablet: '768px',
  laptop: '1000px',
  desktop: '1240px',
};

const containerSizes = {
  form: '450px',
  page: '700px',
  container: '1240px',
  input: '2.625rem',
};

const defaultSizes = {
  px: '1px',
  0: '0px',
  4: '0.25rem',
  8: '0.5rem',
  12: '0.75rem',
  16: '1rem',
  20: '1.25rem',
  24: '1.5rem',
  32: '2rem',
  40: '2.5rem',
  48: '3rem',
  64: '4rem',
  80: '5rem',
  96: '6rem',
  128: '8rem',
  160: '10rem',
  192: '12rem',
  224: '14rem',
  256: '16rem',
  288: '18rem',
  320: '20rem',
};

export const sizes = {
  full: '100%',
  ...deviceSizes,
  ...containerSizes,
  ...defaultSizes,
};
